









































































































































































































































































































































































































































































































































import Vue from 'vue'
import SeismicForm from '@/models/SeismicForm'

export default Vue.extend({
  props: {
    form: { type: [SeismicForm, Object] }
  },
  data: () => {
    return {
      selectedSites: new Set() as Set<string>
    }
  },
  created () {
    this.form.site.forEach((item: string) => this.selectedSites.add(item.toLowerCase()))
    this.$forceUpdate()
  },
  methods: {
    toggleSiteSelection (event: any) {
      console.log(event.target)
      const value = event.target.id || event.target.parentNode.id || event.target.parentNode.parentNode.id || event.target.parentNode.parentNode.parentNode.id
      this.selectedSites.has(value) ? this.selectedSites.delete(value) : this.selectedSites.add(value)
      this.form.site.splice(0, this.form.site.length)
      this.selectedSites.forEach((item: string) => {
        this.form.site.push(item)
      })
      console.log(value, this.form.site)
      this.$forceUpdate()
    }
  },
  beforeDestroy () {
    this.$emit('saveForm', this.form)
  }
})

